import { apiClient } from '@/api/client';
import type { CalendarQueryParams, CalendarResponse } from '@/types/shared';

/**
 * GET /calendar — T103 contract (`packages/shared/src/contracts/calendar.ts`). `from`/`to` are
 * both REQUIRED, Cairo `YYYY-MM-DD` (see `@/lib/calendarDate`'s `computeMonthGridWindow`, which the
 * caller uses to derive them from the visible month grid — never invented here). RBAC/own-scope
 * (Sales Agent) is enforced entirely server-side; a role with zero event types gets a 403 (never
 * reachable client-side — `RoleGuard` + the topbar icon's `CALENDAR_ROLES` check keep that role off
 * this call entirely, T104 §1.5).
 */
export async function getCalendar(params: CalendarQueryParams): Promise<CalendarResponse> {
  const { data } = await apiClient.get<CalendarResponse>('/calendar', { params });
  return data;
}
